import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import GroupNavigator from 'app/components/group/GroupNavigator';

import { container } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...container(theme),
        padding: theme.spacing(3),
    },
    paper: {
        height: '80vh'
    },
}));

export default function MembershipLevels(props) {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Paper className={classes.paper}>
                <GroupNavigator variant="level" title="Membership Levels" singular="Level" />
            </Paper>
        </div>
    );

}
